
import { usePinia, useSearchWizardStore } from '#imports'
import { Component, Vue } from 'vue-property-decorator'
import { ensureArray } from '~/utility/array'

@Component<FilterPanel>({
  head: function () {
    return {
      bodyAttrs: {
        'data-filter-panel': this.searchWizardStore.panelOpen ? 'true' : '',
      },
    }
  },
  setup() {
    const searchWizardStore = useSearchWizardStore(usePinia())
    return { searchWizardStore }
  },
})
export default class FilterPanel extends Vue {
  searchWizardStore: ReturnType<typeof useSearchWizardStore>

  get searchFilters() {
    return this.searchWizardStore.wizardFilters
  }

  alreadyOpened = false

  get placename() {
    return ensureArray(this.$route.query.placename)[0] || undefined
  }

  filterPanelOpened() {
    this.searchWizardStore.panelOpen = true
    if (!this.alreadyOpened) {
      this.alreadyOpened = true
    }
  }

  onFilterCancel() {
    this.searchWizardStore.panelOpen = false
  }

  onFiltersSubmit() {
    this.searchWizardStore.panelOpen = false
  }

  beforeDestroy() {
    this.onFilterCancel
  }

  get isBoundsSearch(): boolean {
    return !!this.searchFilters.bounds
  }

  get facilities() {
    return this.searchFilters.facets || []
  }

  get categoriesCount(): number {
    const categoryIds = this.searchFilters.categoryIds || []
    return categoryIds.length
  }

  get ifCategories(): boolean {
    return !!this.categoriesCount
  }

  get ifPriceRange(): boolean {
    return !!this.searchFilters.priceRange
  }

  get ifShouldShowAppliedFiltersMessage(): boolean {
    return (
      (this.facilities && !!this.facilities.length) ||
      this.isBoundsSearch ||
      this.ifPriceRange ||
      this.ifCategories
    )
  }

  get countOfAppliedFilters(): number {
    const boundsCount = this.isBoundsSearch ? 1 : 0
    const priceCount = this.ifPriceRange ? 1 : 0
    const categoriesCount = this.ifCategories ? this.categoriesCount : 0
    const facilitiesCount = this.facilities ? this.facilities.length : 0
    return facilitiesCount + boundsCount + priceCount + categoriesCount
  }
}
